// 回合倒计时
export const roundTime = 15;

// 初始化定时器时间
export const defaultSeconds = {
    ready: 5, // 游戏开始倒计时
    change: 3, // 换桌倒计时
    round: roundTime, // 玩家回合倒计时
    over: 5, // 结算时间
    autoCall: 0.8, // 自动跟注时间
    roomWaiting: 30, // 弹窗匹配倒计时
};

export const msgTag = {
    Fold: 0,
    CallOnce: 1,
    CallLast: 2,
    RaiseVal: 2,
    View: 3,
    Match: 3,
    Eliminate: 4,
    AllIn: 2,
};
